import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RefundTab } from "./ProductDetailContent.style";
const ProductDetailTerms = (param)=>{
    let { productType  } = param;
    return productType === "aladinbook" ? /*#__PURE__*/ _jsxs(RefundTab, {
        name: "bookShipRefund",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                children: "배송/반품/교환 정보"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "배송 정보"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    children: "도서 배송 상품은 2,500원의 배송 비용이 발생합니다. (도서산간지역 포함, 해외배송의 경우 별도 안내)"
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "도서 배송 비용은 3만원 이상 구매시 무료입니다."
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    children: [
                                        "서책 상품의 경우 결제 확인 후 상품 수령까지 영업일 기준 ",
                                        /*#__PURE__*/ _jsx("b", {
                                            children: "2~4일 정도"
                                        }),
                                        " 소요됩니다."
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "반품/교환 방법"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "content",
                        children: [
                            '" 홈페이지 우측 하단의 상담 버튼 > 대화 > 새 문의하기 > 환불 문의"',
                            " ",
                            /*#__PURE__*/ _jsx("br", {}),
                            "환불 가능 여부 확인 후, 영업일 기준 1~3일 내에 환불 신청이 완료됩니다.",
                            /*#__PURE__*/ _jsx("br", {}),
                            "상품 회수 및 환불 처리 일정은 택배사 상황에 따라 변동될 수 있습니다."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "반품/교환 가능 기간"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsxs("ul", {
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    children: "변심반품: 수령 후 20일"
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "파본 등 상품결함 시: 문제점 발견 후 30일"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "반품/교환 비용"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsx("ul", {
                            children: /*#__PURE__*/ _jsxs("li", {
                                children: [
                                    "단순 변심 혹은 구매 착오의 경우 반송료는 고객이 부담합니다. 단, 아래의 주문/취소 조건인 경우 취소 수수료가 면제됩니다.",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    "- 당일 00시 ~ 24시 주문을 당일 24시 이전에 취소하는 경우"
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "반품/교환 불가 사유"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsxs("ul", {
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    children: "소비자에게 책임이 있는 사유로 인해 상품이 손실 또는 훼손된 경우"
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    children: [
                                        "소비자의 상품 사용, 포장 개봉 등에 의해 상품의 가치가 현저히 감소한 경우 ",
                                        /*#__PURE__*/ _jsx("br", {}),
                                        "예) 랩핑이 제거된 수험서/문제집류"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "상품 구매 시 함께 제공 받은 서비스 혹은 상품을 사용하거나 열람한 경우"
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "반품/교환 가능 기간이 경과한 경우"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "소비자 피해보상/환불지연에 따른 배상"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsxs("ul", {
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    children: "상품의 불량에 의한 반품, 교환, 환불, 품질보증 및 피해보상 등에 관한 사항은 소비자분쟁해결기준 (공정거래위원회 고시) 에 준하여 처리됩니다."
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "대금 환불 및 환불 지연에 따른 배상금 지급 조건, 절차 등은 전자상거래 등에서의 소비자 보호에 관한 법률에 따라 처리함"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }) : productType === "ebook" ? /*#__PURE__*/ _jsxs(RefundTab, {
        name: "refund",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                children: "환불/교환 정보"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "환불 방법"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "content",
                        children: '"홈페이지 우측 하단의 상담 버튼 > 대화 > 새 문의하기 > 환불 문의" 를 통해 환불을 신청할 수 있습니다. 환불 가능 여부 확인 후 영업일 기준 1~3일 내에 환불 신청이 완료됩니다.'
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "환불 가능 기간"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "content",
                        children: "상품을 이용하지 않은 경우 (이용 조건 및 환불 가능 조건은 하기 환불 조건 참고), 결제일로부터 7일 이내에 환불을 요청할 수 있습니다."
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "환불/교환 조건"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsxs("ul", {
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    children: "결제한 eBook 을 굿노트6 앱에서 열람한 이력이 있을 경우 환불 처리가 불가능합니다."
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "굿노트6 앱에서 교재를 실수로 삭제했거나 eBook 상품을 잘못 구매한 경우 쏠북 고객센터에서 “쏠북 매니저 연결하기” 메뉴를 선택해주세요."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ _jsxs(RefundTab, {
        producttype: productType,
        name: "refund",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                children: "환불 기준"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "환불 방법"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsxs("ul", {
                            children: [
                                /*#__PURE__*/ _jsxs("li", {
                                    children: [
                                        "쏠북 서비스 페이지 우측 하단의 상담 버튼 혹은 쏠북 메인 페이지 하단의 고객만족센터 채널톡 문의 버튼을 클릭하고, [문의하기 ",
                                        ">",
                                        " 환불 요청] 버튼을 통해 환불을 요청할 수 있습니다."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "환불 가능 여부 확인 후 영업일 기준 1~3일 내에 순차적으로 환불이 진행됩니다."
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    children: [
                                        "상품 구매 시 사용한 결제 수단을 통해서만 환불이 가능하며, 다른 결제 수단으로의 전환은 불가합니다.",
                                        /*#__PURE__*/ _jsxs("ul", {
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: "단건 구매 시, 이용한 결제 수단으로 취소 처리됩니다."
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: "이용권을 통한 구매 시, 해당 이용권의 재화 형태로 고객에게 복구 혹은 환급 처리됩니다."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "title",
                        children: "환불 가능 조건"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "content",
                        children: /*#__PURE__*/ _jsxs("ul", {
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    children: "상품을 이용하지 않은 경우, 결제일로부터 7일 내에 환불을 요청할 수 있습니다."
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    children: "결제일로부터 7일이 경과한 경우, 상품의 환불 요청이 불가합니다."
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    children: [
                                        "아래의 경우 상품을 이용한 것으로 간주하며, 환불 처리가 불가합니다.",
                                        /*#__PURE__*/ _jsxs("ul", {
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: "자료 보관함에서 상품을 열람하거나, 다운로드한 경우"
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: "쏠북 엑스퍼트 서비스를 통해 상품을 불러오거나 열람한 경우"
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: "(저작권 해결을 위해 구매한 라이선스 상품에 한함) 구매한 라이선스와 연관된 상품을 쏠북 마켓에 판매 등록한 경우"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    children: [
                                        "아래의 경우 환불 가능 여부에 대해 고객센터에 확인을 요청할 수 있습니다.",
                                        /*#__PURE__*/ _jsxs("ul", {
                                            children: [
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: "구매한 상품에 오류가 있는 경우"
                                                }),
                                                /*#__PURE__*/ _jsx("li", {
                                                    children: "기술적인 문제가 발생하여 상품의 이용이 어렵게 된 경우"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
export default ProductDetailTerms;
